/**
 * マーク・アイコンマスタ画面のマーク変換情報一覧クラス
 *
 * @export MarkConvInfoForView
 * @class MarkConvInfoForView
 */
export class MarkConvInfoForView {
    constructor(
        public iconCode: string,
        public iconGroupName: string,
        public iconName: string,
        public iconCodeBranch: string,
        public iconImageUrl: string,
        public markFileName: string,
        public markFileUrl: string
    ) { }
}
